var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","border":"1px solid rgba(63,61,61,0.70)"}},[_c('textarea',{ref:"coder"})])}
var staticRenderFns = []

export { render, staticRenderFns }